import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatError, HERO_IMAGE } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav("/admin"); }
    catch (err) { setError(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 grain" data-testid="admin-login-page">
      <div className="relative hidden lg:block">
        <img src={HERO_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#050507]" />
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-16 py-16">
        <Logo />
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tighter mt-14">Area gestione</h1>
        <p className="text-sm text-zinc-400 mt-3">Accedi per gestire uscite, artisti e messaggi della tua etichetta.</p>
        <form onSubmit={submit} className="mt-10 space-y-4 max-w-sm">
          <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#12141c] border-white/10 h-12" data-testid="admin-login-email-input" />
          <Input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#12141c] border-white/10 h-12" data-testid="admin-login-password-input" />
          {error && <p className="text-sm text-rose-400" data-testid="admin-login-error">{error}</p>}
          <button disabled={loading} className="w-full rounded-full bg-emerald-500 text-black py-3.5 font-semibold hover:bg-emerald-400 disabled:opacity-60 transition-colors" data-testid="admin-login-submit-btn">
            {loading ? "Accesso…" : "Entra"}
          </button>
        </form>
        <Link to="/" className="mt-8 font-mono-tga text-xs uppercase tracking-[0.2em] text-zinc-500 hover:text-white" data-testid="admin-login-back-link">← Torna al sito</Link>
      </div>
    </div>
  );
}
